import { RestProvider } from 'dataSources/types/restProvider';
import { BaseResource } from 'e100-data-providers';
import { ExchangeRequest, ExchangeResponse } from 'entities/cars';
import { SendEmailRequestDto } from '../types/api';

export class ApplicationApi extends BaseResource {
  path: string = '';

  constructor(provider: RestProvider) {
    super(provider);
    this.path = '';
  }

  exchangeMoney(data: ExchangeRequest): Promise<ExchangeResponse> {
    return this.send(this.getChildResource('Exchange/exchangeMoney').request.post().setBody(data));
  }

  sendEmail(emailRequest: SendEmailRequestDto): Promise<void> {
    return this.send(this.getChildResource('Mail/sendEmail').request.post().setBody(emailRequest));
  }
}
